<template>
    <!--begin::App-->
    <div class="d-flex flex-column flex-root app-root ct-theme-medcat big-wp-theme-medcat" id="kt_app_root">
        <!--begin::Page-->
        <div class="app-page flex-column flex-column-fluid" id="kt_app_page" v-if="isInitialized">
            <KTHeader />
            <!--begin::Wrapper-->
            <div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
                <KTSidebar />
                <!--begin::Main-->
                <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
                    <!--begin::Content wrapper-->
                    <div class="d-flex flex-column flex-column-fluid">
                        <!--<KTToolbar />-->
                        <!--<div id="kt_app_content" class="app-content flex-column-fluid">

                        </div>-->
                        <RouterView></RouterView>
                    </div>
                    <!--end::Content wrapper-->
                    <KTFooter />
                </div>
                <!--end:::Main-->
            </div>
            <!--end::Wrapper-->
        </div>
        <!--end::Page-->
    </div>
    <!--end::App-->

    <KTDrawers />
    <KTScrollTop />
    <KTModals />
    <KTCustomize />
    <common-check-session />
    <notification-service-worker />
</template>

<script lang="ts">
    import { SignalRService } from "~/core/services/signalRService";
    import { getToken } from "@/core/services/JwtService";
    import {
        defineComponent,
        nextTick,
        onBeforeMount,
        onMounted,
        watch,
        ref
    } from "vue";
    import KTHeader from "@/layouts/default-layout/components/header/Header.vue";
    import KTSidebar from "@/layouts/default-layout/components/sidebar/Sidebar.vue";
    import KTContent from "@/layouts/default-layout/components/content/Content.vue";
    import KTToolbar from "@/layouts/default-layout/components/toolbar/Toolbar.vue";
    import KTFooter from "@/layouts/default-layout/components/footer/Footer.vue";
    import KTDrawers from "@/layouts/default-layout/components/drawers/Drawers.vue";
    import KTModals from "@/layouts/default-layout/components/modals/Modals.vue";
    import KTScrollTop from "@/layouts/default-layout/components/extras/ScrollTop.vue";
    import KTCustomize from "@/layouts/default-layout/components/extras/Customize.vue";
    import { useRoute } from "vue-router";
    import { reinitializeComponents } from "@/core/plugins/keenthemes";
    import LayoutService from "@/core/services/LayoutService";

    const { stringeeSDK } = useNuxtApp();
    import { useStringeeStore } from '~/stores/stringee';
    export default defineComponent({
        components: {
            KTHeader,
            KTSidebar,
            KTContent,
            KTToolbar,
            KTFooter,
            KTDrawers,
            KTScrollTop,
            KTModals,
            KTCustomize,
        },
        setup() {
            SignalRService.startConnection(getToken());
            const route = useRoute();
            const isInitialized = ref(false);
            const systemStore = useSystemStore();
            const apiClient = useApiClient();
            const tokenStringee = ref("");
            const stringeeStore = useStringeeStore();
            onBeforeMount(async () => {
                LayoutService.init();
                await systemStore.init();
                isInitialized.value = true;
                //systemStore.newsGetCount();
                reinitializeComponents();
            });
            const connectStringee = () => {
                apiClient
                    .generateJwtToken()
                    .then((response) => {
                        if (response) {
                            tokenStringee.value = response;
                            console.log('StringeeUtil.isWebRTCSupported: ' + StringeeUtil.isWebRTCSupported());
                            stringeeStore.client = new StringeeClient();
                            stringeeStore.client.connect(tokenStringee.value);

                            //When the client connects to Stringee Server
                            stringeeStore.client.on('connect', () => {
                                console.log('stringee connected');
                            });
                            //When the client is authenticated
                            stringeeStore.client.on('authen', function (res) {
                                console.log('authen', res);
                                if (res.r === 0) {
                                    console.log('authen success');
                                } else {
                                    console.log('authen error');
                                    apiClient
                                        .generateJwtToken()
                                        .then((token) => {
                                            if (token) {
                                                useStringeeStore.client = new StringeeClient();
                                                useStringeeStore.client.connect(res);
                                            }
                                        });
                                }
                            });
                            //When the client disconnects from Stringee Server
                            stringeeStore.client.on('disconnect', () => {
                                console.log('disconnected');
                            });
                            //When the access_token expires
                            stringeeStore.client.on('requestnewtoken', () => {
                                console.log('requestnewtoken');
                                apiClient
                                    .generateJwtToken()
                                    .then((token) => {
                                        if (token) {
                                            useStringeeStore.client = new StringeeClient();
                                            useStringeeStore.client.connect(res);
                                        }

                                    })
                            });
                        }
                    })
                    .catch(() => {

                    });
            };
            watch(
                () => route.path,
                () => {
                    nextTick(() => {
                        reinitializeComponents();
                    });
                }
            );
            onMounted(() => {
                if (stringeeSDK) {
                    const sdk = new stringeeSDK();
                    sdk.init();
                }
                connectStringee();
            });
            
            return {
                isInitialized
            }
        },
    });
</script>
